import { render } from "./ReservationTimer.vue?vue&type=template&id=764e3b8e"
import script from "./ReservationTimer.vue?vue&type=script&lang=js"
export * from "./ReservationTimer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__